module.exports = __webpack_public_path__ + "img/23-11_ñuñoa_thumb.8e025f93.jpg";